import { LoginSitePickerCtrl } from '../controllers/LoginSitePickerCtrl';
import { Module } from '../Module';

Module.instance().directive('tbLoginSitePicker',
  () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'loginSitePicker.html',
      scope: {},
      controller: LoginSitePickerCtrl
    };
  }
);
